import backendInstance from "../utils/axios/backendInstance";

export const getSplitData = async (tab) => {
  try {
    const response = await backendInstance.get(`/tab-detail/get-split/${tab}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching get split data:", error);
    throw error;
  }
};

export const pause = async (tab) => {
  try {
    const response = await backendInstance.post(`/tab-detail/pause/${tab}`);
    return response.data;
  } catch (error) {
    console.error("Error pausing tab:", error);
    throw error;
  }
};

export const uploadData = async (type, tab, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await backendInstance.post(
      `/tab-detail/upload/${type}/${tab}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading data:", error);
    throw error;
  }
};
